import React from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CountryList from "@/components/country/CountryList";
import BackToTop from "@/components/ui/BackToTop";

const Countries = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12 pt-[97px]">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h1 className="text-3xl md:text-4xl font-bold text-nation-blue mb-4">
              NationCard™ Countries
            </h1>
            <p className="text-lg text-gray-700 max-w-2xl mx-auto">
              Explore all the countries where NationCard™ is available or
              coming soon. Use the filters to find specific countries or browse
              by region.
            </p>
          </div>

          <CountryList />
        </div>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Countries;
